export default "__VITE_ASSET__0JgwBxGm__"